import axios from "axios";

export const validar_ipv4 = async () => {

    let respuesta: boolean = false;

    try {
        const response = await axios.get('https://ipv4.icanhazip.com');
        if (response.status === 200) {
            respuesta = true;
        }
    } catch (error) {
        console.error("Error al obtener la IP:", error);
    }

    return respuesta;

}